export const DEFAULT_DATE_TIME_BLOCK_HEIGHT = 35;
export const DEFAULT_PAYMENT_METHOD_BLOCK_HEIGHT = 30;
export const DEFAULT_QUICK_CHECKOUT_HEIGHT = 330;
export const DEFAULT_TERMS_AND_CONDITIONS_BLOCK = 35;
export const VISITOR_BLOCK_HEIGHT = 145;
export const DEFAULT_ADDING_VISITORS_BLOCK_HEIGHT = 11;
